import styled from "styled-components";
import { motion } from "framer-motion";

export const TopContainerP5 = styled.div`
  width: 100%;
  height: 80px;
  background-color: var(--color-white);
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: sticky;
  top: 0;
  h1 {
    font-size: 18px;
    margin: 10px;
    font-weight: 500;
  }
`;

export const ContainerP5 = styled(motion.div)`
  width: 100%;
  height: calc(100vh - 14vh);
  height: calc(100dvh - 14dvh);
  overflow: scroll;
  position: relative;
  .linear-separation {
    background: linear-gradient(
      180deg,
      #c4c4c4 0%,
      rgba(196, 196, 196, 0) 100%
    );
    width: 100%;
    height: 4px;
    mix-blend-mode: multiply;
    opacity: 0.25;
  }
  @media (max-width: 900px) {
    height: calc(100vh - 8vh);
    height: calc(100dvh - 8dvh);
  }
`;

export const BodyContainerP5 = styled.div`
  width: 100%;
  height: calc(100vh - 182px);
  height: calc(100dvh - 182px);
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-y: scroll;
  overflow-x: hidden;
  position: relative;
  gap: 20px;
  padding: 10px 20px 50px 20px;
  h1 {
    text-align: center;
  }
  z-index: 1;
  margin-top: 30px;
  &::-webkit-scrollbar {
    display: none;
  }
`;

export const ButtonP5 = styled.button`
  width: 250px;
  height: 39px;
  background: var(--color-primary);
  font-size: 16px;
  color: var(--color-white);
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: auto;
  margin-top: 10px;
`;

export const ContainerButton = styled.div`
  position: relative;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
  padding-top: 10px;
  padding-bottom: 30px;
`;

export const ContainerModalCentro = styled.div`
  width: 365px;
  border-bottom-right-radius: 8px;
  border-bottom-left-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 20px;
  padding: 10px;
  .bold {
    font-weight: 500;
  }
  .text-center {
    text-align: center;
  }
  .container-btn {
    display: flex;
    gap: 10px;
  }
  .cancelar {
    width: 122px;
    height: 40px;
    border-radius: 8px;
    color: var(--color-white);
    font-size: 16px;
    font-weight: 500;
    box-shadow: 0 100px 80px rgb(0 0 0 / 7%),
      0 41.7776px 33.4221px rgb(0 0 0 / 5%),
      0 22.3363px 17.869px rgb(0 0 0 / 4%),
      0 12.5216px 10.0172px rgb(0 0 0 / 4%),
      0 6.6501px 5.32008px rgb(0 0 0 / 3%),
      0 2.76726px 2.21381px rgb(0 0 0 / 2%);
  }
  .btn-como-llegar {
    display: flex;
    align-items: center;
    gap: 5px;
    background-color: transparent;
    color: var(--color-latex30);
    border: 2px solid var(--color-latex30);
    border-radius: 6px;
    padding: 10px 14px;
    font-weight: bold;
    cursor: pointer;
    margin-bottom: 10px;
    transition: all 0.2s;
  }
  .container-direccion {
    display: flex;
    align-items: center;
    gap: 4px;
  }
`;
